import React, { useState, useEffect, useRef } from "react";
import triggerFinanceWebhook from "../../Services/FinanceService";
import triggerInsuranceWebhook from "../../Services/InsuranceService";
import triggerRMOWebhook from "../../Services/RMOService";
import { fetchFinanceStatus, fetchInsuranceStatus, fetchRTOStatus, fetchNumberChoices, fetchAnnualSchemes, updateBookingReadyForDelivery, updateInsuranceCaseData, updateRMOCaseData, markBookingTransferCompleted } from "../../Services/DirectusService";
import { fetchBookingTransfers, checkBookingTransferStatus } from "../../Services/BookingTransferService";
import SmWrapper from "../../Components/SmWrapper";
import classes from "../../module.css/UpdateBooking.module.css";
import Heading from "../../tailwindUI/Heading";
import Input from "../../tailwindUI/Input";
import Button from "../../tailwindUI/Button";
import Modal from "../../tailwindUI/Modal";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import { useNavigate, useParams } from "react-router-dom";
import { BsCheckLg } from "react-icons/bs";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
const UpdateBooking = () => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});
  const [physicalDate, setPhysicalDate] = useState("");
  const [apiFailled, setApiFailled] = useState(false);
  const [navigateOnSuccess, setNavigateOnSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [cdd, setCdd] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [filteredList1, setFilteredList1] = useState([]);
  const [filteredList2, setFilteredList2] = useState([]);
  const [yom, setYom] = useState("");
  const [selectedModel1, setSelectedModel1] = useState("");
  const [selectedVariant1, setSelectedVariant1] = useState("");
  const [selectedColor1, setSelectedColor1] = useState("");
  const [selectedModel2, setSelectedModel2] = useState("");
  const [selectedVariant2, setSelectedVariant2] = useState("");
  const [selectedColor2, setSelectedColor2] = useState("");
  const [allocatedPref, setAllocatedPref] = useState(0);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const [commitedDate, setCommitedDate] = useState("");
  const [amount, setAmount] = useState("");
  const [recieptNo, setRecieptNo] = useState("");
  const [reciept, setReciept] = useState("");
  const [asm, setAsm] = useState("");
  const [executive, setExecutive] = useState("");
  const [status, setStatus] = useState("");
  const [statusDate, setStatusDate] = useState("");
  const [vinNumber, setVinNumber] = useState("");
  const [remark, setRemark] = useState("");
  const [followUpOne, setFollowUpOne] = useState("");
  const [followUpTwo, setFollowUpTwo] = useState("");
  const [followUpThree, setFollowUpThree] = useState("");
  const [executiveData, setExecutiveData] = useState([]);
  const [asmData, setAsmData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [markDelivery, setMarkDelivery] = useState("");
  const [carStatus, setCarStatus] = useState("");
  const [defaultAsm, setDefaultAsm] = useState("");
  const [defaultExecutive, setDefaultExecutive] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [markError, setMarkError] = useState({});
  const [exchange, setExchange] = useState("");
  const [checkedPriority, setCheckedPriority] = useState([]);
  const [gatePassNumber, setGatePassNumber] = useState("");
  const [wings, setWings] = useState("");
  const [srmRemark, setSrmRemark] = useState("");
  const [dealAmount, setDealAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [loan, setLoan] = useState("");
  const [finopsData, setFinopsData] = useState(null);
  const [finopsLoading, setFinopsLoading] = useState(false);
  const [insuranceData, setInsuranceData] = useState(null);
  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [rtoData, setRtoData] = useState(null);
  const [rtoLoading, setRtoLoading] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [bookingTransfers, setBookingTransfers] = useState([]);
  const [bookingTransferStatus, setBookingTransferStatus] = useState(null);
  const [updatingTransfer, setUpdatingTransfer] = useState(false);
  const [transferErrorModal, setTransferErrorModal] = useState(false);
  const [transferErrorMessage, setTransferErrorMessage] = useState("");
  const [sendToRTO, setSendToRTO] = useState(false);
  const [sendingToInsurance, setSendingToInsurance] = useState(false);
  const [insuranceSent, setInsuranceSent] = useState(false);
  const [rtoSent, setRtoSent] = useState(false);
  const [choiceNumber, setChoiceNumber] = useState("");
  const [choiceNumberPrompt, setChoiceNumberPrompt] = useState("");
  const [numberSeries, setNumberSeries] = useState("");
  const [readyForDeliveryModal, setReadyForDeliveryModal] = useState(false);
  const [scheme, setScheme] = useState([]);
  const [numberChoices, setNumberChoices] = useState([]);
  const [annualSchemes, setAnnualSchemes] = useState([]);
  const [engineNumber, setEngineNumber] = useState("");
  const [exShowroomPrice, setExShowroomPrice] = useState("");
  const [engineAutoSaved, setEngineAutoSaved] = useState(false);
  const [engineAutoSaving, setEngineAutoSaving] = useState(false);
  const [choiceNumberBookedBy, setChoiceNumberBookedBy] = useState("No"); // No, Yes-Customer, Yes-Us
  const [schemeDropdownOpen, setSchemeDropdownOpen] = useState(false);
  const [otherSchemeText, setOtherSchemeText] = useState("");
  const [deliveryConfirmModal, setDeliveryConfirmModal] = useState(false);
  const schemeDropdownRef = useRef(null);

  // Close scheme dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (schemeDropdownRef.current && !schemeDropdownRef.current.contains(e.target)) {
        setSchemeDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  
  // Check if user is from Telibagh location
  const isTelibaghLocation = localStorage.getItem("Location") === "Telibagh";

  const checkedPriorityInString = checkedPriority
    .map((item) => item.name)
    .toString();

  const [modelList, setModelList] = useState([]);

  useEffect(
    () => FilterList(selectedModel1, setFilteredList1),
    [selectedModel1]
  );
  useEffect(
    () => FilterList(selectedModel2, setFilteredList2),
    [selectedModel2]
  );

  // Fetch all models initially and keep them separate
  useEffect(() => {
    FilterList("", (data) => {
      // console.log("Initial Model List Fetched:", data);
      setModelList(data);
    });
  }, []);

  // Correction effect for Model 1
  useEffect(() => {
    if (modelList?.Model?.length > 0 && selectedModel1) {
      const match = modelList.Model.find(
        (m) => m.toLowerCase() === selectedModel1.toLowerCase()
      );
      if (match && match !== selectedModel1) {
        // console.log(`Auto-correcting Model: ${selectedModel1} -> ${match}`);
        setSelectedModel1(match);
      }
    }
  }, [modelList, selectedModel1]);

  useEffect(() => {
    // console.log("Selected Model 1 Changed:", selectedModel1);
    FilterList(selectedModel1, (data) => {
      // console.log("Filtered List 1 Fetched:", data);
      setFilteredList1(data);
    });
  }, [selectedModel1]);

  // Correction effect for Variant 1
  useEffect(() => {
    if (filteredList1?.Variant?.length > 0 && selectedVariant1) {
      const match = filteredList1.Variant.find((v) => {
        // Option format: "Variant Name (ID)" where ID is digits at the end
        // Incoming format: "Variant Name"

        // 1. Clean the Option: Remove ONLY the trailing ID in parentheses
        // Regex looks for whitespace, literal '(', digits, literal ')', end of string
        const optionClean = v.replace(/\s*\(\d+\)$/, "").trim().toLowerCase();

        // 2. Clean the Incoming value
        const incomingClean = selectedVariant1.trim().toLowerCase();

        return optionClean === incomingClean;
      });

      if (match && match !== selectedVariant1) {
        // console.log(`Auto-correcting Variant: ${selectedVariant1} -> ${match}`);
        setSelectedVariant1(match);
      }
    }
  }, [filteredList1, selectedVariant1]);

  // Correction effect for Color 1
  useEffect(() => {
    if (filteredList1?.Colour?.length > 0 && selectedColor1) {
      const match = filteredList1.Colour.find(
        (c) => c.toLowerCase() === selectedColor1.toLowerCase()
      );
      if (match && match !== selectedColor1) {
        setSelectedColor1(match);
      }
    }
  }, [filteredList1, selectedColor1]);

  useEffect(() => {
    // console.log("Selected Model 2 Changed:", selectedModel2);
    FilterList(selectedModel2, setFilteredList2);
  }, [selectedModel2]);

  useEffect(() => {
    ExecutiveList();
    AsmList();
    BookingDetail();
  }, [asm]);

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };
  const UserToken = localStorage.getItem("UserToken");
  const navigate = useNavigate();
  const { bookingId } = useParams();

  // Fetch Finops status from Directus for Telibagh In House Finance bookings
  useEffect(() => {
    if (bookingId && isTelibaghLocation && paymentMethod === "In House Finance") {
      setFinopsLoading(true);
      fetchFinanceStatus(bookingId)
        .then((data) => setFinopsData(data))
        .catch((err) => console.error("Finops fetch error:", err))
        .finally(() => setFinopsLoading(false));
    }
  }, [bookingId, paymentMethod, isTelibaghLocation]);

  // Fetch Insurance status from Directus - Only for Telibagh (part of Ready for Delivery flow)
  useEffect(() => {
    if (bookingId && isTelibaghLocation) {
      setInsuranceLoading(true);
      fetchInsuranceStatus(bookingId)
        .then((data) => setInsuranceData(data))
        .catch((err) => console.error("Insurance fetch error:", err))
        .finally(() => setInsuranceLoading(false));
    }
  }, [bookingId, isTelibaghLocation]);
  
  // Set Engine Number and Ex-Showroom Price from fetched insurance data
  useEffect(() => {
    if (insuranceData) {
      setEngineNumber(insuranceData.EngineNumber || "");
      setExShowroomPrice(insuranceData.ExShowroomPrice || "");
      if (insuranceData.EngineNumber) setEngineAutoSaved(true);
    }
  }, [insuranceData]);

  // Auto-save Engine Number + ExShowroomPrice to InsuranceCases AND EngineNumber to RMOCases after 1.5s of inactivity
  useEffect(() => {
    if (!engineNumber) return;
    setEngineAutoSaved(false);
    const timer = setTimeout(async () => {
      try {
        setEngineAutoSaving(true);
        const tasks = [];
        if (insuranceData) {
          tasks.push(updateInsuranceCaseData(bookingId, {
            EngineNumber: engineNumber,
            ...(exShowroomPrice ? { ExShowroomPrice: exShowroomPrice } : {}),
          }));
        }
        if (rtoData) {
          tasks.push(updateRMOCaseData(bookingId, { EngineNumber: engineNumber }));
        }
        if (tasks.length > 0) await Promise.all(tasks);
        setEngineAutoSaved(true);
      } catch (err) {
        console.error("Engine auto-save failed:", err);
      } finally {
        setEngineAutoSaving(false);
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, [engineNumber]);

  // Auto-save ExShowroomPrice to InsuranceCases after 1.5s of inactivity
  useEffect(() => {
    if (!exShowroomPrice || !insuranceData) return;
    const timer = setTimeout(async () => {
      try {
        await updateInsuranceCaseData(bookingId, { ExShowroomPrice: exShowroomPrice });
      } catch (err) {
        console.error("ExShowroomPrice auto-save failed:", err);
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, [exShowroomPrice]);


  // Fetch engine number from Wings API (via n8n proxy) when Ready for Delivery modal opens
  useEffect(() => {
    if (!readyForDeliveryModal || !wings || engineNumber) return;
    const fetchWingsEngineNo = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/get_wingsAddress_EngineNo_data`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ WingsBookingId: wings }),
          }
        );
        if (!response.ok) return;
        const result = await response.json();
        console.log("Wings engine no response:", result);
        const data = result?.data;
        const eng = data?.EngineNumber || data?.EngineNo || data?.engine_no;
        const price = data?.ExShowroomPrice || data?.exShowroomPrice;
        if (eng) setEngineNumber(String(eng));
        if (price && !exShowroomPrice) setExShowroomPrice(String(price));
      } catch (err) {
        console.error("Wings engine number fetch error:", err);
      }
    };
    fetchWingsEngineNo();
  }, [readyForDeliveryModal]);

  // Fetch RTO status from Directus - Only for Telibagh (part of Ready for Delivery flow)
  useEffect(() => {
    if (bookingId && isTelibaghLocation) {
      setRtoLoading(true);
      fetchRTOStatus(bookingId)
        .then((data) => setRtoData(data))
        .catch((err) => console.error("RTO fetch error:", err))
        .finally(() => setRtoLoading(false));
    }
  }, [bookingId, isTelibaghLocation]);

  // Fetch Number Choices and Annual Schemes - Only for Telibagh
  useEffect(() => {
    if (isTelibaghLocation) {
      fetchNumberChoices()
        .then((data) => {
          console.log("Number choices fetched:", data);
          setNumberChoices(data);
        })
        .catch((err) => console.error("Number choices fetch error:", err));

      fetchAnnualSchemes()
        .then((data) => {
          console.log("Annual schemes fetched:", data);
          setAnnualSchemes(data);
          if (data.length === 1) {
            console.log("Only one scheme available, auto-selecting:", data[0].SchemeName);
            // Auto-select if only one scheme is available
            setScheme([data[0].SchemeName]);
          }
        })
        .catch((err) => console.error("Annual schemes fetch error:", err));
    }
  }, [isTelibaghLocation]);

  // Fetch booking transfers on component mount - for all locations
  useEffect(() => {
    fetchBookingTransfers()
      .then((data) => setBookingTransfers(data))
      .catch((err) => console.error("Booking transfer fetch error:", err));
  }, []);

  // Check booking transfer status when wings ID changes - for all locations
  useEffect(() => {
    if (wings && bookingTransfers.length > 0) {
      // Pass current booking data to check if transfer is completed
      const currentBookingData = {
        customer_name: firstname,
        LastName: lastname,
      };
      const transferStatus = checkBookingTransferStatus(wings, bookingTransfers, currentBookingData);
      setBookingTransferStatus(transferStatus);
    } else {
      setBookingTransferStatus(null);
    }
  }, [wings, bookingTransfers, firstname, lastname]);

  const ExecutiveList = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      AsmId: asm,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMExicutivesList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setExecutiveData(result.data);
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };
  const AsmList = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMASMList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status_code == 200 && result.status == "Success") {
          setAsmData(result.data);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };
  const FilterList = (model, setFilteredList) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      Model: model,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/common/GetFilterList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" && result.status_code === 200) {
          setFilteredList(result.data);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };
  const BookingDetail = () => {
    setLoading("update");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: UserToken,
      BookingID: bookingId,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMBookingDetails`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success" && result.status_code === 200) {
          // console.log("Booking Detail Fetched:", result.data);
          setSelectedModel1(result.data.car_model);
          setSelectedVariant1(result.data.car_variant);
          setSelectedColor1(result.data.car_colour);
          setSelectedModel2(result.data.CarModel2);
          setSelectedVariant2(result.data.CarVariant2);
          setSelectedColor2(result.data.CarColour2);
          setCarStatus(result.data.carstatus);
          setFirstname(result.data.customer_name);
          setLastName(result.data.LastName);
          setStatusDate(result.data.Statusdate?.slice(0, 10));
          setMobile(result.data.customer_mobile);
          setCommitedDate(result.data.CommittedDeliveryDate);
          setCdd(result.data.CommittedDeliveryDate);
          setDealAmount(result.data.FinalDealAmount);
          setPaymentMethod(result.data.PaymentMethod);
          setLoan(result.data.LoanApproved);
          setAmount(result.data.booking_amount);
          setBookingDate(result.data.booking_date);
          setReciept(result.data.UploadReceipt);
          setRecieptNo(result.data.receipt_num);
          setVinNumber(result.data.win_num);
          setStatus(result.data.status);
          setYom(result.data.yom);
          setWings(result.data.WingsId);
          setExchange(result.data.exchange);
          setDefaultAsm(result.data.AsmName);
          setRemark(result.data.Remark);
          setFollowUpOne(result.data.followup1);
          setFollowUpTwo(result.data.followup2);
          setFollowUpThree(result.data.followup3);
          setDefaultExecutive(result.data.ExecutiveName);
          setPhysicalDate(result.data.PhysicalDate);
          setCheckedPriority(
            result.data.CustomerSpecialNeed.split(",")?.map((item, index) => {
              return {
                name: item,
              };
            })
          );
          if (
            result.data.car_model === result.data.CSModel &&
            result.data.car_colour === result.data.CSColour &&
            result.data.car_variant === result.data.CSVarient
          ) {
            setAllocatedPref(1);
          } else if (
            result.data.CarModel2 === result.data.CSModel &&
            result.data.CarColour2 === result.data.CSColour &&
            result.data.CarVariant2 === result.data.CSVarient
          ) {
            setAllocatedPref(2);
          } else if (result.status_code === 400) {
            setErrorMessage("Something went wrong please contact support !");
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setLoading(""));
  };
  const deliveryDateValidation = () => {
    let error = {};
    let isValid = true;
    if (markDelivery === "") {
      error.markDelivery = "Please select date";
      isValid = false;
    }
    if (gatePassNumber.trim() === "") {
      error.gatePassNumber = "Please enter Gate Pass";
      isValid = false;
    }
    setMarkError(error);
    return isValid;
  };
  const formValidation = () => {
    let errors = {};
    let isValid = true;
    if (!reason || reason === "") {
      errors.reason = "Please select  reason of cancellation";
      isValid = false;
    } else if (reason === "Other" && otherReason === "") {
      errors.otherReason = "Please enter reason of cancellation";
      isValid = false;
    }
    setError(errors);
    return isValid;
  };

  const validation = () => {
    const yomregex = /^[0-9\b]+$/;
    let regPhone = /^[6789][0-9]{9}$/;
    let errors = {};
    let isValid = true;
    if (firstname.trim() === "") {
      isValid = false;
      errors.firstname = "Please enter first name";
    }
    if (lastname.trim() === "") {
      isValid = false;
      errors.lastname = "Please enter last name";
    }
    if (!commitedDate || commitedDate === "") {
      isValid = false;
      errors.commitedDate = "Please enter commited delivery date";
    }
    if (!regPhone.test(mobile)) {
      isValid = false;
      errors.mobile = "Please enter valid mobile number";
    }
    if (dealAmount === "") {
      isValid = false;
      errors.dealAmount = "Please enter Final Deal Amount";
    }
    if (paymentMethod === "") {
      isValid = false;
      errors.paymentMethod = "Please enter Payment Method";
    }
    if (mobile.trim() === "") {
      isValid = false;
      errors.mobile = "Please enter mobile number";
    }
    if (loan === "") {
      isValid = false;
      errors.loan = "Please enter Loan Approved";
    }
    var days = 7;
    var commitDate = new Date(commitedDate);
    var currentDate = new Date(cdd);
    var bookingdate = new Date(bookingDate);

    var last = new Date(currentDate.getTime() + days * 24 * 60 * 60 * 1000);

    if (commitDate < bookingdate) {
      errors.commitedDate =
        "Committed date cannot be earlier than Booking Date";
      window.scrollTo(0, 150);
      isValid = false;
    }
    if ((asm === "" || !asm) && (defaultAsm === "" || !defaultAsm)) {
      errors.asm = "Please select ASM";
      isValid = false;
    }
    if (!yom || yom === "") {
      isValid = false;
      errors.yom = "Please enter year of manufacturing";
    } else if (!yomregex.test(yom) || yom.length < 4) {
      isValid = false;
      errors.yom = "Please enter correct year of manufacturing";
    } else if (yom > new Date().getFullYear() + 2) {
      isValid = false;
      errors.yom = "Year of manufacture should be valid";
    }
    // if (wings === "") {
    //   isValid = false;
    //   errors.wings = "Please enter wings id";
    // }
    // if (checkedPriority.length < 1) {
    //   isValid = false;
    //   errors.checkedPriority = "Please select booking priority";
    //   window.scrollTo(0, 150);
    // }
    if (
      (executive === "" || !executive) &&
      (defaultExecutive === "" || !defaultExecutive)
    ) {
      errors.executive = "Please select Executive";
      isValid = false;
    }

    if (selectedModel1 === "") {
      isValid = false;
      errors.selectedModel1 = "Please select car model";
    }

    if (selectedVariant1 === "") {
      isValid = false;
      errors.selectedVariant1 = "Please select car variant";
    }

    if (selectedColor1 === "") {
      isValid = false;
      errors.selectedColor1 = "Please select car color";
    }

    if (selectedModel2 === "") {
      isValid = false;
      errors.selectedModel2 = "Please select car model";
    }

    if (selectedVariant2 === "") {
      isValid = false;
      errors.selectedVariant2 = "Please select car variant";
    }

    if (selectedColor2 === "") {
      isValid = false;
      errors.selectedColor2 = "Please select car color";
    }

    if (
      selectedModel1 === selectedModel2 &&
      selectedVariant1 === selectedVariant2 &&
      selectedColor1 === selectedColor2 &&
      selectedModel1 !== "" &&
      selectedColor2 !== "" &&
      selectedVariant2 !== ""
    ) {
      isValid = false;
      errors.prefrence2 = "Preference 1 and Preference 2 cannot be same";
    }
    setError(errors);
    return isValid;
  };

  const markDeliveredApi = () => {
    if (deliveryDateValidation()) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        UserToken: UserToken,
        BookingID: bookingId,
        DeliveredOn: markDelivery,
        GetPassNumber: gatePassNumber,
        SRMRemark: srmRemark,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMBookingMarkDelivered`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (
            result.message ===
            "Invalid User Token, The token may have expired, You may need to re-login" ||
            result.message === "Please login with a different account"
          ) {
            LogOut();
          }
          if (result.status_code == 200 && result.status == "Success") {
            setMarkDelivery("");
            setModalShow(false);
            setMessage(
              "Your Mark Delivered request has been sent successfully."
            );
            // Always trigger both insurance and RTO webhooks
            triggerInsuranceWebhook(bookingId);
            triggerRMOWebhook(bookingId);
          } else if (result.status_code === 400) {
            setErrorMessage("Something went wrong please contact support !");
          }
        })
        .catch((error) => {
          console.log("error", error);
          setErrorMessage("Something went wrong please contact support !");
        });
    }
  };

  const handleSendToInsurance = async () => {
    setSendingToInsurance(true);
    setMessage("");
    setErrorMessage("");
    try {
      await triggerInsuranceWebhook(bookingId, engineNumber, exShowroomPrice);

      // Wait 5s then check once if record was inserted
      await new Promise((res) => setTimeout(res, 5000));
      const inserted = await fetchInsuranceStatus(bookingId).catch(() => null);

      if (inserted) {
        // Patch engine number and ex-showroom price into the newly created record
        if (engineNumber || exShowroomPrice) {
          // Small delay to ensure record is fully committed before patching
          await new Promise((res) => setTimeout(res, 1000));
          await updateInsuranceCaseData(bookingId, {
            ...(engineNumber ? { EngineNumber: engineNumber } : {}),
            ...(exShowroomPrice ? { ExShowroomPrice: exShowroomPrice } : {}),
          }).catch((err) => console.warn("Failed to patch insurance fields:", err));
        }
        setInsuranceData({ ...inserted, EngineNumber: engineNumber, ExShowroomPrice: exShowroomPrice });
        setMessage("Insurance record created successfully and is now visible on InsureHub.");
      } else {
        setInsuranceSent(true);
        setErrorMessage(
          "Trigger responded successfully but the insurance record was not created. Please contact support."
        );
      }
    } catch (error) {
      console.error("Insurance webhook error:", error);
      setErrorMessage("Failed to send insurance request. Please check your connection and try again.");
    } finally {
      setSendingToInsurance(false);
    }
  };

  const handleSendToRTO = async () => {
    setSendToRTO(true);
    setMessage("");
    setErrorMessage("");
    try {
      await triggerRMOWebhook(bookingId);

      // Wait 5s then check once if record was inserted
      await new Promise((res) => setTimeout(res, 5000));
      const inserted = await fetchRTOStatus(bookingId).catch(() => null);

      if (inserted) {
        setRtoData(inserted);
        setMessage("RTO record created successfully and is being processed.");
        // Also write Engine Number to RMOCases if available
        if (engineNumber) {
          try {
            await updateRMOCaseData(bookingId, { EngineNumber: engineNumber });
            console.log("Engine number written to RMOCases.");
          } catch (rmoErr) {
            console.error("Failed to write engine number to RMOCases:", rmoErr);
          }
        }
      } else {
        setRtoSent(true);
        setErrorMessage(
          "Trigger responded successfully but the RTO record was not created. Please contact support."
        );
      }
    } catch (error) {
      console.error("RTO webhook error:", error);
      setErrorMessage("Failed to send RTO request. Please check your connection and try again.");
    } finally {
      setSendToRTO(false);
    }
  };

  const markDeliveredButtonShow = () => {
    var commitDate = new Date(commitedDate);
    var PhysicalDate = new Date(physicalDate);
    var lastCommitedDate = new Date(
      PhysicalDate.getTime() + 5 * 24 * 60 * 60 * 1000
    );
    var lastPhysicalDate = new Date(
      commitDate.getTime() + 2 * 24 * 60 * 60 * 1000
    );
    var currentDate = new Date();
    if (currentDate > lastCommitedDate && currentDate > lastPhysicalDate) {
      return true;
    } else {
      return false;
    }
  };
  const markDeliveredShow = markDeliveredButtonShow();

  // Check if Finops status allows delivery - only for Telibagh and In House Finance
  const isInHouseFinance = isTelibaghLocation && paymentMethod === "In House Finance";
  const finopsDeliverable =
    !isInHouseFinance ||
    (finopsData &&
      ["Disbursed", "Agreement Signed"].includes(finopsData.Status));

  // Document URLs from Finops record - Only Disbursed Cases and Agreement Signed
  const finopsDocumentFields = [
    { label: "Disbursed Cases", url: finopsData?.DisbursedCasesURL },
    { label: "Agreement Signed", url: finopsData?.AgreementSignedURL },
  ].filter((doc) => doc.url);
  const bookingPriorityList = [
    {
      name: "Full Payment",
    },

    {
      name: "Special Occasion",
    },

    {
      name: "Committed Date",
    },
    {
      name: "Owner Reference",
    },
    {
      name: "Other Reference",
    },
  ];
  const priorityCheckboxHandler = (option) => {
    const isChecked = checkedPriority.some((item) => item.name === option.name);
    if (isChecked) {
      setCheckedPriority(
        checkedPriority.filter((item) => item.name !== option.name)
      );
    } else {
      setCheckedPriority(checkedPriority.concat(option));
    }
  };
  const cancelReasons = [
    { id: 1, name: "Color not available" },
    { id: 2, name: "Bought from other dealer" },
    { id: 3, name: "Not interested" },
    { id: 4, name: "Other" },
  ];

  const CancelBooking = () => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      BookingID: bookingId,
      CancelledReason: reason === "Other" ? otherReason : reason,
      UserToken: UserToken,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMMarkedCancel`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (
          result.status_code == 200 &&
          result.status == "Success" &&
          result.message !== "Data not  Updated "
        ) {
          setOpen(false);
          setApiFailled(false);
          setMessage("Booking cancelled successfully");
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        } else {
          setOpen(false);
          setApiFailled(true);
          setMessage("Data not updated");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      });
  };
  const updateBookingData = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      BookingID: bookingId,
      FirstName: firstname,
      LastName: lastname,
      LastName: lastname,
      MobileNumber: mobile,
      Model: selectedModel1,
      Variant: selectedVariant1,
      Colour: selectedColor1,
      Model2: selectedModel2,
      Variant2: selectedVariant2,
      Colour2: selectedColor2,
      FinalDealAmount: dealAmount,
      YOM: yom,
      DateOfBooking: bookingDate,
      CommittedDeliveryDate: commitedDate,
      BookingPriority: checkedPriorityInString,
      // Status: status,
      // VinNo: vinNumber,
      PaymentMethod: paymentMethod,
      LoanApproved: loan,
      Exchange: exchange,
      ASM: asm,
      Executive: executive,
      // StatusDate: statusDate,
      Followup1: followUpOne,
      Remark: remark,
      Followup2: followUpTwo,
      Followup3: followUpThree,
      UserToken: UserToken,
      WingsId: wings,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMBookingUpdated`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success" && result.status_code === 200) {
          setApiFailled(false);
          window.scrollTo(0, 0);
          setNavigateOnSuccess(true);
          setMessage("Data updated successfully");
          // Trigger Finance Webhook
          if (bookingId) {
            triggerFinanceWebhook(bookingId);
          }
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support !");
        } else {
          setApiFailled(true);
          window.scrollTo(0, 0);
          setMessage("Something went wrong please contact support.");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setLoading(false));
  };
  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
      if (!apiFailled && navigateOnSuccess) {
        navigate("/sm-search-update");
      }
    }, 2000);
    return message;
  };

  const updateBookingFromTransfer = async () => {
    if (!wings) {
      setTransferErrorMessage("Wings ID is required to update booking transfer");
      setTransferErrorModal(true);
      return;
    }

    setUpdatingTransfer(true);
    
    try {
      const response = await fetch(
        `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/update-booking-from-booking-transfer`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            WingsId: wings,
          }),
        }
      );

      // Try to parse as JSON, fallback to text
      let result;
      let responseText;
      try {
        responseText = await response.text();
        result = JSON.parse(responseText);
      } catch (parseError) {
        // If JSON parsing fails, use the text response
        result = { message: responseText };
      }

      // Get the message from various possible fields
      const responseMessage = (
        result.message || 
        result.error || 
        result.status || 
        result.data?.message ||
        result.data?.error ||
        responseText ||
        ""
      ).toString();
      
      const messageLower = responseMessage.toLowerCase();

      console.log("N8N Response:", result); // Debug log
      console.log("Response Message:", responseMessage); // Debug log
      console.log("Message Lower:", messageLower); // Debug log

      // Check for success
      if (messageLower.includes("success") || messageLower.includes("completed") || messageLower.includes("transferred") || messageLower.includes("updated successfully")) {
        setMessage("The booking transfer has been completed successfully.");
        setApiFailled(false);
        // Mark the transfer as completed in Directus so STM panel can see it
        markBookingTransferCompleted(wings).catch(console.error);
        
        // Reload booking data only on success
        setTimeout(() => {
          BookingDetail();
          // Refresh booking transfers
          fetchBookingTransfers()
            .then((data) => setBookingTransfers(data))
            .catch((err) => console.error("Booking transfer fetch error:", err));
        }, 1000);
      } 
      // Check for Aadhaar/PAN error (including "kyc not updated" and "booking data not found" messages)
      else if (
        messageLower.includes("booking data not found") || 
        messageLower.includes("kyc not updated") ||
        messageLower.includes("kyc") ||
        messageLower.includes("aadhaar") || 
        messageLower.includes("aadhar") || 
        messageLower.includes("pan") || 
        messageLower.includes("cashier") || 
        messageLower.includes("document") || 
        messageLower.includes("upload")
      ) {
        setTransferErrorMessage("Please ask the Cashier to upload the Aadhaar and PAN of the new customer.");
        setTransferErrorModal(true);
      } 
      // Default: show the actual message from n8n or generic error
      else {
        const displayMessage = responseMessage.trim() || "Please ask the Cashier to upload the Aadhaar and PAN of the new customer.";
        setTransferErrorMessage(displayMessage);
        setTransferErrorModal(true);
      }
    } catch (error) {
      console.error("Error updating booking transfer:", error);
      setTransferErrorMessage("Failed to update booking transfer. Please contact support.");
      setTransferErrorModal(true);
    } finally {
      setUpdatingTransfer(false);
    }
  };

  const onlyNumeric = (e, setState) => {
    var reg = /^-?\d+$/;
    reg.test(e.target.value) || e.target.value === ""
      ? setState(e.target.value)
      : console.log("");
  };

  const onlyNumericMobile = (e) => {
    var reg = /^[0-9\b]+$/;

    reg.test(e.target.value) || e.target.value === ""
      ? setMobile(e.target.value)
      : console.log("");
    error.mobile = "";
  };
  const BreadCrumb = {
    pagename1: "Update booking",
    pagePath1: "/sm-update-booking/" + bookingId,
    pagename: "Bookings",
    pagePath: "/sm-search-update",
  };

  const checkStatus1 = () => {
    return (
      status === "Allocated" ||
      status === "AutoAllocationCancelled" ||
      status === "CarAllocated" ||
      status === "DeliveryRequested" ||
      status === "AllocatedButVinAwaited"
    );
  };
  const notificationMethods = [
    { id: "Yes", title: "Yes" },
    { id: "No", title: "No" },
  ];
  const loanOptions = [
    { id: "Yes1", title: "Yes" },
    { id: "No1", title: "No" },
  ];
  const checkStatus2 = () => {
    return status === "Delivered" || status === "Cancelled";
  };

  return (
    <SmWrapper>
      {message && (
        <SuccessMessage
          onClose={() =>
            (!apiFailled && navigateOnSuccess) ? navigate("/sm-search-update") : setMessage("")
          }
          apiFailled={apiFailled}
          message={successMessage()}
        />
      )}
      {errorMessage && <ErrorMessage message={errorMessage} />}
      {transferErrorModal && (
        <Modal
          setOpen={setTransferErrorModal}
          open={transferErrorModal}
          type="Simple alert"
          heading={"Booking Transfer Update Failed"}
          onCancel={() => setTransferErrorModal(false)}
          desc={transferErrorMessage}
          onClick={() => setTransferErrorModal(false)}
        >
        </Modal>
      )}
      {open && (
        <Modal
          setOpen={setOpen}
          desc={"Are you sure you want to cancel the booking"}
          heading={"Cancel booking"}
          open={open}
          onCancel={() => setOpen(false)}
          onClick={() =>
            formValidation() ? CancelBooking() : console.log("err")
          }
          type="Simple alert"
        >
          <div className={classes.modalInputContainer}>
            <Input
              type={"Select Menus Simple native low height"}
              dropdownType="cancelreason"
              data={cancelReasons}
              label={"Reason"}
              error={error.reason}
              onInput={() => (error.reason = "")}
              onChange={(e) => {
                setReason(e.target.value);
              }}
            />
            <p class="peer-invalid:visible text-red-500 font-light">
              {error.reason}
            </p>
            <div className={classes.selectInput}>
              {reason === "Other" && (
                <Input
                  type={"textarea"}
                  error={error.otherReason}
                  placeholder={"Explain the reason of cancellation in detail"}
                  onChange={(e) => {
                    setOtherReason(e.target.value);
                  }}
                />
              )}
              <p class="peer-invalid:visible text-red-500 font-light">
                {error.otherReason}
              </p>
            </div>
          </div>
        </Modal>
      )}
      
      {/* Ready for Delivery Modal */}
      {readyForDeliveryModal && (
        <Modal
          setOpen={setReadyForDeliveryModal}
          open={readyForDeliveryModal}
          type="Simple alert"
          heading={"Ready for Delivery"}
          onCancel={() => {
            setReadyForDeliveryModal(false);
            // Reset states
            setNumberSeries("");
            setScheme([]);
            setSchemeDropdownOpen(false);
            setOtherSchemeText("");
            setShowDocuments(false);
            setInsuranceSent(false);
            setRtoSent(false);
            setChoiceNumberBookedBy("No");
          }}
          desc={"Complete all the required steps before marking as ready for delivery"}
          onClick={() => {
            const finopsComplete = !isInHouseFinance || finopsDeliverable;
            const insuranceOkFinal = !!insuranceData;
            const numberChoiceComplete = true; // Number choice dropdown removed from modal
            const hasOthers = scheme.includes("Others");
            const schemeComplete = annualSchemes.length > 0
              ? (scheme.length > 0 && (!hasOthers || otherSchemeText.trim().length > 0))
              : true;

            console.log("Validation:", { finopsComplete, insuranceOkFinal, numberChoiceComplete, schemeComplete, isInHouseFinance, finopsDeliverable, finopsData, insuranceData, numberSeries, scheme, otherSchemeText });

            if (!finopsComplete || !insuranceOkFinal || !numberChoiceComplete || !schemeComplete) {
              alert("Please complete all parameters before proceeding");
              return;
            }
            // Open delivery confirmation popup
            setReadyForDeliveryModal(false);
            setDeliveryConfirmModal(true);
          }}
        >
          <div className={classes.modalInput}>
            {/* Finops Status Warning for In House Finance */}
            {isInHouseFinance && !finopsDeliverable && (
              <div className="mb-4 px-4 py-3 rounded-md text-sm font-medium bg-yellow-50 text-yellow-800 border border-yellow-200 flex items-start">
                <span className="text-lg mr-2">⚠️</span>
                <div>
                  <strong>Warning:</strong> Finops status is '{finopsData?.Status || "Not found"}'. 
                  <br />Expected status: 'Disbursed' or 'Agreement Signed'
                </div>
              </div>
            )}

            {/* FINOPS Section - Only show for In House Finance */}
            {isInHouseFinance && (
              <div className="mb-4 p-4 border border-gray-200 rounded-lg bg-white">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex items-start flex-1">
                    <div className="flex-1">
                      <span className="block text-base font-semibold text-gray-900">
                        FINOPS
                      </span>
                      <div className="mt-1">
                        {finopsDeliverable && (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            ✓ {finopsData?.Status}
                          </span>
                        )}
                        {!finopsDeliverable && (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                            Status: {finopsData?.Status || "Not found"}
                          </span>
                        )}
                      </div>
                      {/* Finops Documents — inline inside FINOPS section */}
                      {isTelibaghLocation && finopsData && (
                        <div className="mt-3">
                          {finopsDocumentFields.length > 0 ? (
                            <div className="space-y-2">
                              {finopsDocumentFields.map((doc, idx) => (
                                <div key={idx} className="flex items-center justify-between bg-blue-50 border border-blue-100 rounded-md px-3 py-2">
                                  <div className="flex items-center">
                                    <span className="text-blue-600 mr-2">📄</span>
                                    <span className="text-sm font-medium text-gray-800">{doc.label}</span>
                                  </div>
                                  <a
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-3 py-1 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 transition-colors"
                                  >
                                    View
                                  </a>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-xs text-gray-500">Documents will appear here once uploaded by the finance team.</p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* INSURANCE Section */}
            <div className="mb-4 p-4 border border-gray-200 rounded-lg bg-white">
              <div className="flex items-start gap-3">
                <div className="flex-1">
                  <span className="block text-base font-semibold text-gray-900">
                    INSURANCE
                  </span>
                  <div className="mt-1">
                    {insuranceData && (insuranceData.InsuranceDocumentURL || insuranceData.PolicyDocument) && (
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-green-100 text-green-800">✓ Documents Uploaded</span>
                    )}
                    {insuranceData && !(insuranceData.InsuranceDocumentURL || insuranceData.PolicyDocument) && (
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-yellow-100 text-yellow-800">✓ Record Sent to Insurance</span>
                    )}
                    {!insuranceData && sendingToInsurance && (
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-blue-100 text-blue-800">⏳ Sending & verifying...</span>
                    )}
                    {!insuranceData && !sendingToInsurance && insuranceSent && (
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-red-100 text-red-800">⚠ Record not created — contact support</span>
                    )}
                    {!insuranceData && !sendingToInsurance && !insuranceSent && (
                      <span className="text-xs text-gray-500">Not Requested</span>
                    )}
                  </div>

                  {/* Engine Number and Ex-showroom Price */}
                  <div className="mt-3 grid grid-cols-2 gap-4">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <label className="block text-xs font-semibold text-gray-700 uppercase">Engine Number</label>
                        {engineAutoSaving && <span className="text-xs text-blue-500 animate-pulse">saving...</span>}
                        {!engineAutoSaving && engineAutoSaved && <span className="text-xs text-green-600 font-semibold">✓ Saved</span>}
                        {insuranceData && <span className="text-xs text-gray-500">🔒 Locked</span>}
                      </div>
                      <input
                        type="text"
                        placeholder="Enter Engine Number"
                        value={engineNumber}
                        onChange={(e) => !insuranceData && setEngineNumber(e.target.value)}
                        readOnly={!!insuranceData}
                        className={`block w-full rounded-md border px-3 py-2 text-sm focus:outline-none ${
                          insuranceData
                            ? "border-gray-200 bg-gray-50 text-gray-600 cursor-not-allowed"
                            : "border-gray-300 focus:ring-2 focus:ring-blue-500"
                        }`}
                      />
                    </div>
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <label className="block text-xs font-semibold text-gray-700 uppercase">Ex-showroom Price (₹)</label>
                        {insuranceData && <span className="text-xs text-gray-500">🔒 Locked</span>}
                      </div>
                      <input
                        type="number"
                        placeholder="Enter Price"
                        value={exShowroomPrice}
                        onChange={(e) => !insuranceData && setExShowroomPrice(e.target.value)}
                        readOnly={!!insuranceData}
                        className={`block w-full rounded-md border px-3 py-2 text-sm focus:outline-none ${
                          insuranceData
                            ? "border-gray-200 bg-gray-50 text-gray-600 cursor-not-allowed"
                            : "border-gray-300 focus:ring-2 focus:ring-blue-500"
                        }`}
                      />
                    </div>
                  </div>
                  {!insuranceData && (
                    <p className="mt-1 text-xs text-amber-600">⚠ Insurance record not yet created — these values will be saved when the insurance record is available.</p>
                  )}

                  {/* Send button — bottom right */}
                  {!insuranceData && (
                    <div className="mt-4 flex justify-end">
                      <button
                        type="button"
                        onClick={handleSendToInsurance}
                        disabled={sendingToInsurance || !engineNumber.trim() || !exShowroomPrice}
                        className="px-5 py-2 bg-blue-600 text-white text-sm font-semibold rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors disabled:bg-blue-400 disabled:cursor-not-allowed"
                      >
                        {sendingToInsurance ? "SENDING..." : "Send"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Applicable HMIL Schemes — multi-select dropdown */}
            {annualSchemes.length > 0 && (
              <div className="mb-4 relative" ref={schemeDropdownRef}>
                <label className="block text-sm font-semibold text-gray-900 mb-2 uppercase">
                  Applicable HMIL Schemes
                </label>
                {/* Trigger button */}
                <button
                  type="button"
                  onClick={() => setSchemeDropdownOpen((o) => !o)}
                  className="w-full flex items-center justify-between px-4 py-2.5 text-sm border border-gray-300 rounded-md bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <span className={scheme.length === 0 ? "text-gray-400" : "text-gray-900"}>
                    {scheme.length === 0
                      ? "Select Scheme"
                      : scheme.join(", ")}
                  </span>
                  <svg className={`h-4 w-4 text-gray-500 transition-transform ${schemeDropdownOpen ? "rotate-180" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {/* Dropdown panel */}
                {schemeDropdownOpen && (
                  <div className="absolute z-20 bottom-full mb-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-40 overflow-y-auto">
                    {annualSchemes.map((item) => (
                      <label
                        key={item.Id}
                        className="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-gray-50"
                      >
                        <input
                          type="checkbox"
                          checked={scheme.includes(item.SchemeName)}
                          onChange={(e) => {
                            setScheme(e.target.checked
                              ? [...scheme, item.SchemeName]
                              : scheme.filter((s) => s !== item.SchemeName)
                            );
                          }}
                          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <span className="text-sm text-gray-800">
                          {item.SchemeName}{item.Description ? ` — ${item.Description}` : ""}
                        </span>
                      </label>
                    ))}
                  </div>
                )}
                {scheme.length === 0 && (
                  <p className="mt-1 text-xs text-amber-600">⚠ Select at least one scheme to proceed.</p>
                )}
                {scheme.includes("Others") && (
                  <div className="mt-2">
                    <input
                      type="text"
                      placeholder="Please specify the scheme..."
                      value={otherSchemeText}
                      onChange={(e) => setOtherSchemeText(e.target.value)}
                      className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {!otherSchemeText.trim() && (
                      <p className="mt-1 text-xs text-amber-600">⚠ Please specify the scheme name.</p>
                    )}
                  </div>
                )}
              </div>
            )}

            <div className="mt-5 pt-4 border-t border-gray-200 text-xs text-gray-600 italic">
              * All parameters must be completed to proceed
            </div>
          </div>
        </Modal>
      )}

      {/* Delivery Confirmation Popup */}
      {deliveryConfirmModal && (
        <Modal
          setOpen={setDeliveryConfirmModal}
          open={deliveryConfirmModal}
          type="Simple alert"
          heading={"Delivery Details"}
          onCancel={() => {
            setDeliveryConfirmModal(false);
            setMarkDelivery("");
            setGatePassNumber("");
            setSrmRemark("");
          }}
          desc={"Enter the delivery details to complete the process"}
          onClick={async () => {
            if (!markDelivery) {
              alert("Please select a Date of Delivery.");
              return;
            }
            if (!gatePassNumber || gatePassNumber.trim() === "") {
              alert("Please enter the Gate Pass Number.");
              return;
            }
            try {
              setLoading(true);
              const myHeaders = new Headers();
              myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
              myHeaders.append("Content-Type", "application/json");
              const raw = JSON.stringify({
                UserToken: localStorage.getItem("UserToken"),
                BookingID: bookingId,
                DeliveredOn: markDelivery,
                GetPassNumber: gatePassNumber,
                SRMRemark: srmRemark,
              });
              const markDeliveredRes = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/srm/SRMBookingMarkDelivered`,
                { method: "POST", headers: myHeaders, body: raw, redirect: "follow" }
              );
              const markDeliveredResult = await markDeliveredRes.json();

              if (markDeliveredResult.status_code === 200 && markDeliveredResult.status === "Success") {
                await updateBookingReadyForDelivery(bookingId, {
                  NumberChoice: numberSeries,
                  SchemeName: scheme.map(s => s === "Others" && otherSchemeText.trim() ? otherSchemeText.trim() : s).join(","),
                }).catch((e) => console.warn("updateBookingReadyForDelivery skipped:", e));

                setMessage("Booking marked as delivered successfully.");
                setDeliveryConfirmModal(false);
                setNavigateOnSuccess(true);
              } else {
                setErrorMessage(markDeliveredResult.message || "Failed to mark as delivered. Please contact support.");
              }
            } catch (error) {
              console.error("Error marking booking as delivered:", error);
              setErrorMessage("Failed to mark as delivered. Please contact support.");
            } finally {
              setLoading(false);
            }
          }}
        >
          <div className={classes.modalInput}>
            <div className="p-4 border border-indigo-200 rounded-lg bg-indigo-50">
              <h4 className="text-sm font-semibold text-indigo-900 mb-4 uppercase tracking-wide">Delivery Details (Required)</h4>
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Date of Delivery</label>
                  <input
                    type="date"
                    value={markDelivery}
                    onChange={(e) => setMarkDelivery(e.target.value)}
                    className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Gate Pass Number</label>
                  <input
                    type="text"
                    placeholder="Enter Gate Pass"
                    value={gatePassNumber}
                    onChange={(e) => setGatePassNumber(e.target.value)}
                    className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">SRM Remark (Optional)</label>
                <input
                  type="text"
                  placeholder="Enter remark"
                  value={srmRemark}
                  onChange={(e) => setSrmRemark(e.target.value)}
                  className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
      
      {modalShow && (
        <Modal
          setOpen={setModalShow}
          open={modalShow}
          type="Simple alert"
          heading={"Mark Delivered"}
          onCancel={() => {
            setModalShow(false);
            setShowDocuments(false);
          }}
          desc={"Are you sure you want mark this car as delivered ?"}
          onClick={() => markDeliveredApi()}
        >
          <div className={classes.modalInput}>
            {/* Finops Status Banner for In House Finance only */}
            {isInHouseFinance && (
              <div
                className={`my-2 px-3 py-2 rounded text-sm font-medium ${
                  finopsLoading
                    ? "bg-gray-100 text-gray-600"
                    : finopsDeliverable
                    ? "bg-green-50 text-green-700 border border-green-200"
                    : "bg-red-50 text-red-700 border border-red-200"
                }`}
              >
                {finopsLoading
                  ? "Checking Finops status..."
                  : finopsData
                  ? `Finops Status: ${finopsData.Status}`
                  : "No Finops record found for this booking"}
              </div>
            )}

            <div className="my-2">
              <Input
                type={"input with label low height"}
                inputType={"date"}
                label={"Date of Delivery"}
                onChange={(e) => setMarkDelivery(e.target.value)}
              />
              <span className="text-red-500"> {markError.markDelivery}</span>
            </div>

            <div className="my-2">
              <Input
                type={"input with label low height"}
                inputType={"text"}
                label={"Gate Pass Number"}
                onChange={(e) => {
                  setGatePassNumber(e.target.value);
                  markError.gatePassNumber = "";
                }}
                value={gatePassNumber}
              />
              <span className="text-red-500"> {markError.gatePassNumber}</span>
            </div>
            <div className="my-2">
              <Input
                type={"input with label low height"}
                inputType={"text"}
                label={"SRM Remark (Optional)"}
                onChange={(e) => setSrmRemark(e.target.value)}
                value={srmRemark}
              />
            </div>

            {/* View Documents Section (In House Finance only) - Enhanced */}
            {isTelibaghLocation && finopsData && (
              <div className="mb-4 p-4 border-2 border-blue-200 rounded-lg bg-blue-50">
                <h4 className="text-sm font-semibold text-blue-900 mb-2">Finops Documents</h4>
                {finopsDocumentFields.length > 0 ? (
                  <div className="space-y-2">
                    {finopsDocumentFields.map((doc, idx) => (
                      <div key={idx} className="flex items-center justify-between bg-white border border-blue-100 rounded-md px-3 py-2">
                        <div className="flex items-center">
                          <span className="text-blue-600 mr-2">📄</span>
                          <span className="text-sm font-medium text-gray-800">{doc.label}</span>
                        </div>
                        <a
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-3 py-1 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700 transition-colors"
                        >
                          View
                        </a>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-xs text-gray-600">
                    Documents will appear here once uploaded by the finance team.
                  </p>
                )}
              </div>
            )}
          </div>
        </Modal>
      )}
      <div className={classes.HeadingWrapper}>
        <div className={classes.innerWrapper}>
          <Heading
            BreadCrumb={BreadCrumb}
            BreadCrumHomeLink={"/sm-dashboard"}
            headingType={"Page Headings"}
            headingText={"Update Booking"}
          />
        </div>
        <div className={classes.buttonWrapper}>
          <div className="flex gap-3 items-center">
            {/* Ready for Delivery button - Only for Telibagh */}
            {carStatus === "Physical" && isTelibaghLocation && (
              <Button
                type={status === "Delivered" || status === "DeliveryRequested" ? "pinkLong" : "blueFilled"}
                onClick={() => {
                  if (status !== "Delivered" && status !== "DeliveryRequested") setReadyForDeliveryModal(true);
                }}
                buttonText={
                  status === "Delivered" ? "Already Delivered" :
                  status === "DeliveryRequested" ? "Delivery Requested" :
                  "Ready for Delivery"
                }
                disabled={status === "Delivered" || status === "DeliveryRequested"}
              />
            )}

            {/* Mark Delivered button - For non-Telibagh locations */}
            {carStatus === "Physical" && !isTelibaghLocation && (
              <Button
                type={
                  (bookingTransferStatus && !bookingTransferStatus._isCompleted)
                    ? "pinkLong"
                    : finopsDeliverable
                    ? "greenFilled"
                    : "pinkLong"
                }
                onClick={() => {
                  if (bookingTransferStatus && !bookingTransferStatus._isCompleted) {
                    alert("Mark Delivered is not allowed while a Booking Transfer is pending. Please complete the booking transfer first.");
                    return;
                  }
                  if (finopsDeliverable) {
                    setModalShow(true);
                  } else {
                    alert(
                      `Mark Delivered is only available when Finops status is 'Disbursed' or 'Agreement Signed'. Current status: ${finopsData?.Status || "Not found"}`
                    );
                  }
                }}
                buttonText="Mark Delivered"
              />
            )}

            {/* Update Booking Record button */}
            {bookingTransferStatus && (
              <Button
                type={"blueFilled"}
                onClick={updateBookingFromTransfer}
                buttonText={updatingTransfer ? "Updating..." : "Update Booking Record"}
                loading={updatingTransfer}
              />
            )}

            {/* Booking Cancellation button */}
            {!checkStatus2() && (
              <Button
                type={"redFilled"}
                onClick={() => setOpen(true)}
                buttonText={"Booking Cancellation"}
              />
            )}
          </div>
        </div>
      </div>
      {loading === "update" ? (
        <div className={classes.loader}>
          {" "}
          <img src="../assets/loadingGif.gif" alt="loading" />
        </div>
      ) : (
        <div className={classes.mainContainer}>
          {status === "Delivered" ? (
            <div className="my-2 mb-4 text-red-500">
              Bookings that are delivered cannot be modified. Please request
              Delivery cancel first.{" "}
            </div>
          ) : (
            <></>
          )}
          <div
            className={
              checkStatus2()
                ? classes.searchContainerDisabled
                : classes.searchContainer
            }
          >
            <div className={classes.headingFormContainer}>
              <Heading
                headingType={"sub heading small"}
                headingText={"Customer Details"}
              />

              <div className={classes.inputRow}>
                <div className={(checkStatus1() || Boolean(recieptNo && recieptNo.trim())) ? classes.inputDisable : ""}>
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => {
                      setFirstname(e.target.value);
                      error.firstname = "";
                    }}
                    value={firstname}
                    error={error.firstname}
                    label={"First Name"}
                    disabled={checkStatus1() || Boolean(recieptNo && recieptNo.trim())}
                  />
                  <p class="peer-invalid:visible text-red-500 font-light">
                    {error.firstname}
                  </p>
                </div>
                <div className={(checkStatus1() || Boolean(recieptNo && recieptNo.trim())) ? classes.inputDisable : ""}>
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      error.lastname = "";
                    }}
                    value={lastname}
                    error={error.lastname}
                    label={"Last Name"}
                    disabled={checkStatus1() || Boolean(recieptNo && recieptNo.trim())}
                  />
                  <p class="peer-invalid:visible text-red-500 font-light">
                    {error.lastname}
                  </p>
                </div>
                <div className={(checkStatus1() || Boolean(recieptNo && recieptNo.trim())) ? classes.inputDisable : ""}>
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => onlyNumericMobile(e)}
                    value={mobile}
                    maxLength={10}
                    label={"Mobile Number"}
                    error={error.mobile}
                    disabled={checkStatus1() || Boolean(recieptNo && recieptNo.trim())}
                  />
                  <p class="peer-invalid:visible textcheckStatus1-red-500 font-light">
                    {error.mobile}
                  </p>
                </div>
                <div
                  className={
                    checkStatus2()
                      ? classes.inputWrapper
                      : classes.inputWrapperDisable
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => setAmount(e.target.value)}
                    value={amount}
                    label={"Booking Amount"}
                  />
                </div>
                <div className={classes.inputDisable}>
                  <Input
                    type={"Select Menus Simple native low height"}
                    asmData={asmData}
                    dropdownType={"AsmList"}
                    onChange={(e) => {
                      setAsm(e.target.value);
                      error.asm = "";
                    }}
                    value={asm}
                    selected={defaultAsm}
                    error={error.asm}
                    label={"ASM"}
                  />
                  <p class="peer-invalid:visible text-red-500 font-light">
                    {error.asm}
                  </p>
                </div>

                <div className={classes.inputDisable}>
                  <Input
                    type={"Select Menus Simple native low height"}
                    executiveData={executiveData}
                    dropdownType={"ExecutiveList"}
                    onChange={(e) => {
                      setExecutive(e.target.value);
                      error.executive = "";
                    }}
                    value={executive}
                    selected={defaultExecutive}
                    error={error.executive}
                    label={"Executive"}
                  />
                  <p class="peer-invalid:visible text-red-500 font-light">
                    {error.executive}
                  </p>
                </div>
              </div>
              <div className={classes.inputRow}>
                <div
                  className={
                    checkStatus2() ? classes.input : classes.inputDisable
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"date"}
                    onChange={(e) => setBookingDate(e.target.value)}
                    value={bookingDate}
                    label={"Date of Booking"}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
                <div
                  className={
                    checkStatus1() ? classes.inputDisable : classes.input
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"date"}
                    onChange={(e) => {
                      setCommitedDate(e.target.value);
                      error.commitedDate = "";
                    }}
                    value={commitedDate}
                    error={error.commitedDate}
                    label={"Commited Delivery Date"}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  <p class="peer-invalid:visible text-red-500 font-light">
                    {error.commitedDate}
                  </p>
                </div>
                <div className={classes.inputDisable}>
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    label={"WINGS ID"}
                    onChange={(e) => {
                      setWings(e.target.value);
                      error.wings = "";
                    }}
                    value={wings}
                    error={error.wings}
                  />
                  <span className={classes.error}>{error.wings}</span>
                </div>
                <div>
                  <div className="block text-sm font-medium text-gray-700">
                    Booking priority
                  </div>
                  <Input
                    type={"Select Menus with checkbox"}
                    label={"Booking Priority *"}
                    // disable={true}
                    data={bookingPriorityList}
                    error={error.checkedPriority}
                    priorityCheckboxHandler={priorityCheckboxHandler}
                    checkedPriority={checkedPriority}
                  // errors={errors}
                  />
                  <p class="peer-invalid:visible text-red-500 font-light">
                    {error.checkedPriority}
                  </p>
                </div>

                <div
                  className={
                    checkStatus2()
                      ? classes.inputWrapper
                      : classes.inputWrapperDisable
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => setRecieptNo(e.target.value)}
                    value={recieptNo}
                    label={"Receipt No"}
                  />
                </div>
                {/* <div className={classes.inputWrapper}>
                  <label
                    htmlFor={"Upload Receipt"}
                    className="block text-sm font-medium text-gray-700 "
                  >
                    Upload Receipt
                  </label>
                  <div
                    className={` w-full mt-1 flex rounded-md border-gray-300 px-2 py-1 border  sm:text-sm  focus:border-indigo-500 focus:ring-indigo-500`}
                  >
                    <a
                      className={classes.recieptUrl}
                      target="_blank"
                      href={reciept}
                    >
                      Receipt
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
            <div className={classes.headingFormContainer}>
              <Heading
                headingType={"sub heading small"}
                headingText={"Vehicle preference"}
              />
              <div>
                <div className={classes.preferenceWrapper}>
                  <div>
                    <div className={classes.preference}>
                      Preference 1
                      {allocatedPref === 1 ? (
                        <BsCheckLg className={classes.checkIcon} />
                      ) : (
                        <></>
                      )}
                    </div>
                    <div
                      className={classes.preferenceRow}
                    >
                      <div>
                        <Input
                          type={"Select Menus Simple native low height"}
                          label={"Model *"}
                          dropdownType={"Model"}
                          filteredData={modelList}
                          // model={selectedModel1}
                          value={selectedModel1}
                          onChange={(e) => {
                            setSelectedModel1(e.target.value);
                            error.selectedModel1 = "";
                          }}
                          disabled={checkStatus1() || Boolean(recieptNo && recieptNo.trim())}
                          error={error.selectedModel1}
                        />
                        <p className="peer-invalid:visible text-red-500 font-light">
                          {error.selectedModel1}
                        </p>
                      </div>
                      <div>
                        <Input
                          type={"Select Menus Simple native low height"}
                          label={"Variant *"}
                          value={selectedVariant1}
                          dropdownType={"Variant"}
                          filteredData={filteredList1}
                          onChange={(e) => {
                            setSelectedVariant1(e.target.value);
                            error.selectedVariant1 = "";
                          }}
                          disabled={checkStatus1() || Boolean(recieptNo && recieptNo.trim())}
                          error={error.selectedVariant1}
                        />
                        <p className="peer-invalid:visible text-red-500 font-light">
                          {error.selectedVariant1}
                        </p>
                      </div>
                      <div>
                        <Input
                          type={"Select Menus Simple native low height"}
                          label={"Color *"}
                          dropdownType={"Color"}
                          value={selectedColor1}
                          filteredData={filteredList1}
                          onChange={(e) => {
                            setSelectedColor1(e.target.value);
                            error.selectedColor1 = "";
                          }}
                          disabled={false}
                          error={error.selectedColor1}
                        />
                        <p className="peer-invalid:visible text-red-500 font-light">
                          {error.selectedColor1}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className={classes.preference}>
                      Preference 2
                      {allocatedPref === 2 ? (
                        <BsCheckLg className={classes.checkIcon} />
                      ) : (
                        <></>
                      )}
                    </div>

                    <div
                      className={
                        checkStatus1()
                          ? `${classes.preferenceRow} ${classes.dropDownWrapperDisable}`
                          : classes.preferenceRow
                      }
                    >
                      <div>
                        <Input
                          type={"Select Menus Simple native low height"}
                          label={"Model *"}
                          dropdownType={"Model"}
                          filteredData={modelList}
                          value={selectedModel2}
                          onChange={(e) => {
                            setSelectedModel2(e.target.value);
                            error.selectedModel2 = "";
                            error.prefrence2 = "";
                          }}
                          disabled={checkStatus1()}
                          error={error.selectedModel2}
                        />
                        <p className="peer-invalid:visible text-red-500 font-light">
                          {error.selectedModel2}
                        </p>
                      </div>
                      <div>
                        <Input
                          type={"Select Menus Simple native low height"}
                          label={"Variant *"}
                          dropdownType={"Variant"}
                          value={selectedVariant2}
                          filteredData={filteredList2}
                          onChange={(e) => {
                            setSelectedVariant2(e.target.value);
                            error.selectedVariant2 = "";
                            error.prefrence2 = "";
                          }}
                          disabled={checkStatus1()}
                          error={error.selectedVariant2}
                        />
                        <p className="peer-invalid:visible text-red-500 font-light">
                          {error.selectedVariant2}
                        </p>
                      </div>
                      <div>
                        <Input
                          type={"Select Menus Simple native low height"}
                          label={"Color *"}
                          dropdownType={"Color"}
                          value={selectedColor2}
                          filteredData={filteredList2}
                          onChange={(e) => {
                            setSelectedColor2(e.target.value);
                            error.selectedColor2 = "";
                            error.prefrence2 = "";
                          }}
                          disabled={checkStatus1()}
                          error={error.selectedColor2}
                        />
                        <p className="peer-invalid:visible text-red-500 font-light">
                          {error.selectedColor2}
                        </p>
                      </div>
                    </div>
                  </div>
                  <span className={classes.error}>{error.prefrence2}</span>
                </div>
              </div>
            </div>
            <div>
              <Heading
                headingType={"sub heading small"}
                headingText={"Other Details"}
              />
              <div className={classes.inputRow}>
                <div
                  className={
                    checkStatus1()
                      ? classes.inputWrapperDisable
                      : classes.inputWrapper
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => {
                      setYom(e.target.value);
                      error.yom = "";
                    }}
                    value={yom}
                    error={error.yom}
                    maxLength="4"
                    min="4"
                    label={"YOM"}
                  />
                  <span className="text-red-500"> {error.yom}</span>
                </div>
                {/* <div>
                  <div
                    className={
                      checkStatus2()
                        ? classes.inputWrapper
                        : classes.inputWrapperDisable
                    }
                  >
                    <Input
                      type={"Select Menus Simple native low height"}
                      type={"input with label low height"}
                      inputType={"text"}
                      onChange={(e) => setStatus(e.target.value)}
                      dropdownType={"status"}
                      statusData={statusData}
                      value={status}
                      label={"Status"}
                    />
                  </div>
                </div>
                <div
                  className={
                    checkStatus2()
                      ? classes.inputWrapper
                      : classes.inputWrapperDisable
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"date"}
                    onChange={(e) => setStatusDate(e.target.value)}
                    value={statusDate}
                    label={"Status Date"}
                  />
                </div>
                <div
                  className={
                    checkStatus2()
                      ? classes.inputWrapper
                      : classes.inputWrapperDisable
                  }
                >
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    onChange={(e) => setVinNumber(e.target.value)}
                    value={vinNumber}
                    label={"Vin No."}
                  />
                </div> */}
                <div>
                  <div>
                    <Input
                      type={"radio group"}
                      label="Exchange "
                      value={exchange}
                      setState={setExchange}
                      data={notificationMethods}
                    />
                  </div>
                </div>

                <div className={checkStatus1() && classes.inputDisable}>
                  <Input
                    type={"input with label low height"}
                    inputType={"text"}
                    label={"Final Deal Amount *"}
                    value={dealAmount}
                    onChange={(e) => {
                      onlyNumeric(e, setDealAmount);
                      error.dealAmount = "";
                    }}
                    error={error.dealAmount}
                  />
                  <span className={classes.error}>{error.dealAmount}</span>
                </div>

                <div className={checkStatus1() && classes.inputDisable}>
                  <label
                    className=" text-sm font-medium text-gray-700"
                    htmlFor="paymentdropdown"
                  >
                    Payment Method *
                  </label>
                  <br />
                  <select
                    className={`block w-full border  outline-none text-sm rounded-md border-gray-300 px-2   ${error.paymentMethod
                      ? "border-red-500 focus:ring-orange-500 bg-white"
                      : "focus:border-indigo-500 focus:ring-indigo-500 bg-white"
                      }`}
                    id="paymentdropdown"
                    value={paymentMethod}
                    onChange={(e) => {
                      setPaymentMethod(e.target.value);
                    }}
                  >
                    <option value="" disabled>
                      Select Payment Method
                    </option>
                    <option value="Cash ">Cash </option>
                    <option value="Self Finance">Self Finance</option>
                    <option value="In House Finance">In House Finance</option>
                  </select>

                  <span className={classes.error}>{error.paymentMethod}</span>
                </div>

                <div className={classes.radiobuttonWrapper}>
                  <div className={checkStatus1() && classes.inputDisable}>
                    <Input
                      type={"radio group loan"}
                      label="Loan Approved *"
                      value={loan}
                      setState={setLoan}
                      data={loanOptions}
                    />

                    <span className={classes.error}>{error.loan}</span>
                  </div>
                </div>
              </div>

              <div className={classes.rigthSide}>
                <div className={`${classes.inputWrapper} `}>
                  <Input
                    type={"textarea"}
                    inputType={"text"}
                    onChange={(e) => setRemark(e.target.value)}
                    value={remark}
                    placeholder={" "}
                    label={"Remark"}
                    rows={1}
                  />
                </div>

                <div className={classes.inputWrapper}>
                  <Input
                    type={"textarea"}
                    inputType={"text"}
                    onChange={(e) => setFollowUpOne(e.target.value)}
                    value={followUpOne}
                    placeholder={" "}
                    label={"Follow Up 1"}
                    rows={1}
                  />
                </div>
                <div className={classes.inputWrapper}>
                  <Input
                    type={"textarea"}
                    inputType={"text"}
                    onChange={(e) => setFollowUpTwo(e.target.value)}
                    value={followUpTwo}
                    placeholder={" "}
                    rows={1}
                    label={"Follow Up 2"}
                  />
                </div>
                <div className={classes.inputWrapper}>
                  <Input
                    type={"textarea"}
                    inputType={"text"}
                    onChange={(e) => setFollowUpThree(e.target.value)}
                    value={followUpThree}
                    rows={1}
                    placeholder={" "}
                    label={"Follow Up 3"}
                  />
                </div>
              </div>
              <div className={classes.submitButtonWrapper}>
                <Button
                  type={"whiteButton"}
                  onClick={() => navigate("/sm-search-update")}
                  buttonText={"Cancel"}
                />
                <div className={classes.submitButton}>
                  <Button
                    type={"smallButton"}
                    onClick={() =>
                      validation() ? updateBookingData() : console.log("err")
                    }
                    buttonText={"Save"}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </SmWrapper>
  );
};

export default UpdateBooking;